/*
 * Project: BookingEngine
 * Module: components/icons/CheckIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';

const CheckIcon = () => (
  <svg className="svg-icon check-icon" width="14px" height="14px" viewBox="0 0 18 14" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g className="theme-path" fillRule="evenodd" transform="translate(-15, -20)">
      <polygon points="15 26 19 26 21 29 29 20 33 20 21 34" />
    </g>
  </svg>
);

export default CheckIcon;
